import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './views/shared/menu/menu.component';
import { HomeComponent } from './views/home/home.component';
import { DishComponent } from './views/dish/dish.component';
import { InfoMenuComponent } from './views/info-menu/info-menu.component';

import { DragScrollModule } from 'ngx-drag-scroll';
import { NgxLoadingModule } from "ngx-loading";

import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatSliderModule} from '@angular/material/slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ToastrModule } from 'ngx-toastr';
import { ReplaceNoPipe } from './replace-no.pipe';
import { CurrencyDisplayPipe } from './currency-display.pipe';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginRegisterComponent } from './views/shared/login-register/login-register.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { ChatComponent } from './views/shared/chat/chat.component';
import { UiTranslatePipe } from './ui-translate.pipe';

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    HomeComponent,
    DishComponent,
    InfoMenuComponent,
    ReplaceNoPipe,
    CurrencyDisplayPipe,
    LoginRegisterComponent,
    ChatComponent,
    UiTranslatePipe
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AppRoutingModule,
    NgbCollapseModule,
    HttpClientModule,
    DragScrollModule,
    NgxLoadingModule.forRoot({}),
    CarouselModule,
    SlickCarouselModule,
    NgxSliderModule,
    BrowserAnimationsModule,
    MatSliderModule,
    ToastrModule.forRoot(),
    NgOtpInputModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
